/* eslint-disable @typescript-eslint/no-explicit-any */
import { Row } from 'antd';
import React, { useContext } from 'react';
import axiosInstance from '../../../../axios_instance';
import { IsAdminContext } from '../../../../context';
import { BaseUrlGeneral } from '../../../../utils';
import styles from './styles.module.scss';

interface ResumeProps {
  file_name: string;
  url: string;
}

const Resume: React.FC<ResumeProps> = ({
  file_name,
  url,
}: ResumeProps): JSX.Element => {
  const isAdmin = useContext(IsAdminContext);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onDelete = (e: any) => {
    let req_url = '';
    if (isAdmin === '1') {
      req_url = '/api/v1/admin/files/';
    } else {
      req_url = '/api/v1/profile/files/';
    }
    axiosInstance
      .delete(BaseUrlGeneral + req_url + url.split('/')[4])
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then((response) => {
        window.location.reload();
      });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onDownload = (e: any) => {
    let req_url = '';
    if (isAdmin === '1') {
      req_url = 'api/v1/admin/files/response/';
    } else {
      req_url = '/api/v1/profile/files/response/';
    }
    axiosInstance.defaults.headers['Content-Type'] = 'application/pdf';
    axiosInstance
      .get(BaseUrlGeneral + req_url + url.split('/')[4], {
        responseType: 'blob',
      })
      // .then((response : any) => response.blob())
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file_name);
        document.body.appendChild(link);
        link.click();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        link.parentNode!.removeChild(link);
      });
  };

  return (
    <>
      <Row className={styles['resume-file']}>
        <span style={{ marginRight: '5px', cursor: 'pointer' }}>
          <img src="/picture_as_pdf.png"></img>
        </span>
        <span style={{ marginLeft: '0px', marginRight: '0px' }}>
          <p>{file_name.slice(0, 6) + '_.pdf'}</p>
        </span>
      </Row>
      <span style={{ marginRight: '10px', cursor: 'pointer' }}>
        <img src="/download.png" onClick={onDownload}></img>
      </span>
      <span>
        <img
          onClick={onDelete}
          src="/delete.png"
          style={{
            marginRight: '10px',
            cursor: 'pointer',
            display: isAdmin === '1' ? 'none' : '',
          }}
        ></img>
      </span>
      <br />
    </>
  );
};

export default Resume;
